module.exports = __webpack_public_path__ + "static/media/temp.d6e723b8.png";